module.exports = __webpack_public_path__ + "img/jamaica.8d7c3494.jpg";